import { generateTranslations } from '../i18n/translation';

const namespace = 'practiceactivity/calendarCell.uha';

const translations = generateTranslations(namespace, {
  manglerBehov: {
    nb: 'Mangler estimert behov',
    en: 'Missing estimated need',
  },
  kanDeles: {
    nb: 'Klar til å deles',
    en: 'Ready to be shared',
  },
  deltMenManglerKapasitet: {
    nb: 'Delt men mangler kapasitet',
    en: 'Shared but missing capacity',
  },
  deltOgHarKapasitet: {
    nb: 'Delt og har oppfylt kapasitet',
    en: 'Shared and has fulfilled capacity',
  },
  venterPaaOnskeliste: {
    nb: 'Ønskeliste aktiv',
    en: 'Wish list available',
  },
  studenterManglerKlasse: {
    nb: 'Studenter mangler klasse',
    en: 'Students missing class',
  },
  studenterManglerPlass: {
    nb: 'Studenter mangler plass',
    en: 'Students missing placement',
  },
  alleStudenterFordelt: {
    nb: 'Studentfordeling er ikke delt med praksissted',
    en: 'Student placement not shared with practice places',
  },
  fordelingsresultatDelt: {
    nb: 'Alle studenter er fordelt',
    en: 'All student have been placed',
  },
  gjennomfoert: {
    nb: 'Gjennomført',
    en: 'Completed',
  },
  avtalefeil: {
    nb: 'Avtalefeil: Aktiviteten har bestillinger og/eller besvarelser som faller utenfor en avtale.',
    en: 'Agreement error: The activity has orders and/or responses that are not connected to an agreement.',
  },
  fsFeilPublisering: {
    nb: 'Feil ved publisering av aktivitet til FS.',
    en: 'Error when publishing activity to FS.',
  },
  fsFeilUkjent: {
    nb: 'Ukjent feil i FS påvirker aktiviteten.',
    en: 'Unknown FS error affects activity.',
  },
});

export default translations;
